<template>
    <div class="layout-footer">
        <img alt="Logo" :src="footerImage()" height="20" class="mr-2" />
        <span class="font-medium ml-2">Heal &copy; {{ new Date().getFullYear() }}</span>
    </div>
</template>

<script>
import GetStreamService from '@/libs/getstream'
export default {
    name: 'AppFooter',
    components: {},
    data() {
        return {
            user: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : 'undefined'
        }
    },
    computed: {
        darkTheme() {
            return this.$appState.darkTheme
        }
    },
    methods: {
        footerImage() {
            return this.$appState.darkTheme ? require('@/assets/images/logo-white.svg') : require('@/assets/images/logo-dark.svg')
        },
        async requestMediaPermissions() {
            try {
                // Check if permissions are already granted
                const permissions = await navigator.permissions.query({ name: 'camera' })
                const micPermissions = await navigator.permissions.query({ name: 'microphone' })

                // Only request if permissions are not granted
                if (permissions.state === 'denied' || micPermissions.state === 'denied') {
                    console.log('Media permissions already denied, skipping request')
                    return
                }

                if (permissions.state === 'granted' && micPermissions.state === 'granted') {
                    console.log('Media permissions already granted')
                    return
                }

                // Request permissions only if not already granted or denied
                const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
                stream.getTracks().forEach((track) => track.stop())
                console.log('Media permissions granted successfully')
            } catch (error) {
                console.error('Failed to request media permissions:', error)
            }
        },
        async getReadyForStream() {
            await GetStreamService.initialize()
        }
    },
    mounted() {
        if (this.user !== 'undefined' && this.user.doctor) {
            this.getReadyForStream()
            this.requestMediaPermissions()
        }
    }
}
</script>
